import { useContext } from 'react';
import styled, { css } from 'styled-components';
import {
  isPlatformAdmin,
  isTenantAdmin,
  UserContext
} from '../../contexts/UserContext';
import { createMenuItems, MenuItem } from '../atoms';
import {
  authenticatedPathNames,
  authenticatedPaths,
  merchantAdminPathNames,
  merchantAdminPaths,
  platformAdminPathNames,
  platformAdminPaths
} from '../../routes/Paths';

const SidebarMenuHeader = styled.div(
  ({ theme }) => css`
    color: ${theme.colors.white};
    padding: ${theme.paddings.md} ${theme.paddings.md} ${theme.paddings.xs};

    @media (max-width: ${theme.breakpoints.max.md}) {
      padding: ${theme.paddings.sm} ${theme.paddings.sm} ${theme.paddings.xs};
    }
  `
);

const SidebarMenuHeading = styled.h2`
  font-size: 1.75rem !important;
  margin-bottom: 0;
`;

const SidebarMenuSubHeading = styled.h3(
  ({ theme }) => css`
    @media (max-width: ${theme.breakpoints.max.md}) {
      font-size: 1.125rem !important;
    }
  `
);

const SidebarMenuFooter = styled.div`
  margin-top: auto;
`;

const Separator = styled.div(
  ({ theme }) => css`
    border-top: ${theme.borders.normalWhite};
    margin: ${theme.margins.md} ${theme.margins.md} ${theme.margins.sm};

    @media (max-width: ${theme.breakpoints.max.md}) {
      margin: ${theme.margins.sm} ${theme.margins.sm} ${theme.margins.xs};
    }
  `
);

const SidebarMenu = () => {
  const {
    user: { userType, merchantId },
    originalUser: { userType: orginalUserType, merchantId: originalMerchantId },
    userInfo: { name }
  } = useContext(UserContext);
  const originalMenuItems = createMenuItems(orginalUserType);
  const userMenuItems = createMenuItems(userType);
  const combinedMenuItems = [...originalMenuItems, ...userMenuItems];
  const dedupedMenuArray = [
    ...new Map(combinedMenuItems.map((item) => [item['title'], item])).values()
  ];
  const menuItems = dedupedMenuArray;
  return (
    <>
      <div>
        <SidebarMenuHeader>
          <SidebarMenuHeading id="sidebar-menu-heading">
            Welcome
          </SidebarMenuHeading>
          <SidebarMenuSubHeading className="h2" id="sidebar-menu-name">
            {name}
          </SidebarMenuSubHeading>
          {merchantId !== originalMerchantId && (
            <SidebarMenuSubHeading className="h2">
              Viewing as: <u>{merchantId}</u>
            </SidebarMenuSubHeading>
          )}
          {process.env.REACT_APP_ENV !== 'production' && (
            <SidebarMenuSubHeading className="h2">
              commitId: {process.env.REACT_APP_COMMIT_ID}
            </SidebarMenuSubHeading>
          )}
        </SidebarMenuHeader>

        {menuItems.map((item, index) => {
          return (
            <MenuItem
              to={item.path}
              icon={item.icon}
              text={item.title}
              key={index}
            />
          );
        })}
      </div>
      <SidebarMenuFooter>
        <Separator></Separator>
        {isTenantAdmin(userType) &&
          merchantAdminPathNames.map((pathName, index) => {
            const { title, path, icon } = merchantAdminPaths[pathName];
            return (
              <MenuItem
                id={title === 'Logout' ? 'logout-button' : undefined}
                to={path}
                icon={icon}
                text={title}
                key={index}
              />
            );
          })}
        {isPlatformAdmin(userType) &&
          platformAdminPathNames.map((pathName, index) => {
            const { title, path, icon } = platformAdminPaths[pathName];
            return (
              <MenuItem
                id={title === 'Logout' ? 'logout-button' : undefined}
                to={path}
                icon={icon}
                text={title}
                key={index}
              />
            );
          })}
        {authenticatedPathNames.map((pathName, index) => {
          const { title, path, icon } = authenticatedPaths[pathName];
          return (
            <MenuItem
              id={title === 'Logout' ? 'logout-button' : undefined}
              to={path}
              icon={icon}
              text={title}
              key={index}
            />
          );
        })}
      </SidebarMenuFooter>
    </>
  );
};

export { SidebarMenu };
